import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import TransferForm from '../components/TransferForm';
import config from '../config';
const TransferPage = () => {
    // Local state for transfer form
    const [amount, setAmount] = useState(0);
    const [recipientAccount, setRecipientAccount] = useState('');
    // Load the external security support widget
    useEffect(() => {
        const script = document.createElement('script');
        const conversationServiceUrl = config.conversationServiceUrl || config.REACT_APP_CONVERSATION_SERVICE_URL;
        const cdnUrl = config.cdnUrl;
        if (!conversationServiceUrl) {
            console.error('❌ No conversation service URL configured');
            return;
        }
        if (!cdnUrl) {
            console.error('❌ No CDN URL configured for transfer page');
            return;
        }
        script.src = `${cdnUrl}/widgets/conversation-widget.min.js`;
        script.async = true;
        // Add initialization attributes - no auto-init, no auto-show
        script.setAttribute('data-support-platform-url', conversationServiceUrl);
        script.setAttribute('data-application-id', config.bankApiKey);
        script.setAttribute('data-auto-show', 'false'); // Don't auto-show
        script.setAttribute('data-target-element', 'transfer-container');
        script.setAttribute('data-position', 'attached-to-element');
        script.setAttribute('data-flow-context', 'prevent');
        script.onload = () => {
            console.log('✅ Security Widget Bundle loaded successfully');
        };
        script.onerror = () => {
            console.error('❌ Failed to load Security Widget Bundle');
        };
        document.head.appendChild(script);
        // Cleanup on unmount
        return () => {
            if (window.ConversationWidget) {
                window.ConversationWidget.destroy();
            }
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);
    function sendMockTransaction() {
        if (window.ConversationWidget && typeof window.ConversationWidget.sendMessage === 'function') {
            const mockTransferData = {
                source: 'bundle-demo',
                transfer: {
                    id: 'demo-txn-' + Date.now(),
                    toAccount: 'ES76 2100 0813 6101 2345',
                    amount: amount || 15000,
                    location: 'Madrid, Spain',
                    currency: 'EUR'
                },
                riskLevel: 'HIGH',
                riskFactors: ['new_recipient', 'large_amount', 'international_transfer'],
                timestamp: new Date().toISOString()
            };
            const customerMessage = 'Looks like you want to transfer ' + mockTransferData.transfer.amount + ' ' + mockTransferData.transfer.currency + ' to ' + mockTransferData.transfer.toAccount + ' in ' + mockTransferData.transfer.location + '.';
            console.log('🎯 Sending mock transaction message:', customerMessage);
            window.ConversationWidget.sendMessage(customerMessage);
        }
        else {
            console.log('⚠️ sendMessage method not available on widget');
        }
    }
    const handleScamDetected = async (supportAccessToken) => {
        console.log('🚨 Scam detected! Triggering security support widget...');
        // Dispatch scam detection event
        document.dispatchEvent(new CustomEvent('scamDetected', {
            detail: {
                transferAmount: amount || 15000,
                recipientAccount: recipientAccount || 'suspicious-account-123',
                riskFactors: ['new_recipient', 'large_amount', 'international_transfer'],
                timestamp: new Date().toISOString()
            }
        }));
        // Show widget with actual transfer context
        if (window.ConversationWidget) {
            console.log('🔒 Showing security widget with transfer context');
            window.ConversationWidget.show({
                targetElement: 'transfer-container',
                context: {
                    source: 'transfer-form',
                    transfer: {
                        id: `txn-${Date.now()}`,
                        toAccount: recipientAccount || 'ES76 2100 0813 6101 2345',
                        amount: parseFloat(amount.toString()) || 15000,
                        location: 'Madrid, Spain',
                        currency: 'EUR'
                    }
                }
            });
            // Send mock transaction message after widget is shown
            setTimeout(() => {
                sendMockTransaction();
            }, 1000);
        }
        else {
            console.log('🔒 Widget not loaded yet, event dispatched instead');
        }
    };
    return (_jsx("div", { className: "page transfer-page", children: _jsx(TransferForm, { onScamDetected: handleScamDetected, amount: amount, onAmountChange: setAmount, recipientAccount: recipientAccount, onRecipientAccountChange: setRecipientAccount }) }));
};
export default TransferPage;
